import React, {useEffect} from "react";
import { inject } from "mobx-react";
import { HOUSE_VIEWS } from "constants/houses";
import Houses from "containers/Houses";
import BaseLayout from "components/Layouts/BaseLayout";
import HelmetIntl from 'components/Meta/HelmetIntl';
import { formatSearchParams } from "utils/helpers/searchHelper";


const FavoritesPage = ({ housesStore })  => {
  useEffect(() => {
    housesStore.setView(HOUSE_VIEWS.favorites);
  }, []);

  const handleGetHousesData = (criteriaData, isMapView, handleSuccess, handleError) => {
    const searchParams = { filters: formatSearchParams(criteriaData) };
    isMapView
      ? housesStore.getHousesFavoritesMapRequest(searchParams)
      : housesStore.getHousesFavoritesRequest(searchParams, handleSuccess, handleError);
  };

  return (
    <BaseLayout>
      <HelmetIntl id="helmet.favoritesTitle" />
      <Houses handleGetHousesData={handleGetHousesData} view={HOUSE_VIEWS.favorites} />
    </BaseLayout>
  )
}

export default inject('housesStore')(FavoritesPage);
